const configService = {
  apiUrl: "https://platzi-music-api.herokuapp.com",
};

export default configService;
